import React from "react";

const TransferSection = ({ producto }) => {
  return (
    <div className="card transfer">
      <div className="card-header" id="headingThree">
        <h5>
          <button
            className="btn btn-link"
            data-toggle="collapse"
            data-target="#collapseThree"
            aria-expanded="true"
            aria-controls="collapseThree"
          >
            Transfer
            <i className="material-icons">keyboard_arrow_up</i>
          </button>
        </h5>
      </div>
      <div
        id="collapseThree"
        className="collapse accordion-info show"
        aria-labelledby="headingThree"
        data-parent="#accordion"
      >
        <div className="card-body">
          <h4> {producto.transfer}</h4>
        </div>
      </div>
    </div>
  );
};

export default TransferSection;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/FichaReserva/transferSection.js